import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { FeatureGateBanner } from "@/components/banners/feature-gate-banner/feature-gate-banner";
import { AppCalloutBanner } from "@/components/banners/app-callout-banner";

export const PageBannerSection: FC = observer(() => {
  return (
    <Wrapper>
      <AppCalloutBanner />
      <FeatureGateBanner />
    </Wrapper>
  );
});

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 16,
});
